import type { Components } from '@mui/material/styles';

import type { Theme } from '../types';

export const MuiDialogActions = {
  styleOverrides: { root: { gap: '8px', padding: '16px 24px 24px' } },
} satisfies Components<Theme>['MuiDialogActions'];
